"use strict";
/*
 *
 *@description:认证相关
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-07-28 17:32:50
 *
*/
Object.defineProperty(exports, "__esModule", { value: true });
//个人信息模态框认证是独立的
/**
    * 获取认证相关数据
    * 先判断bigvip=1 再根据OrganizationType判断是蓝V还是橙V
    * 再用 organizationtype 字段判断下是个人（001开头）还是非个人
    * 个人（最多三种）：1. 身份认证 qulificationinfo 字段 字段有值就显示 没值不加(黄V)
    *                 2. 自媒体认证 qualificationInfo_Zmt 字段有值就显示 没值不加(黄V)
    *                 3. 个性认证 qualificationInfo_GX 字段有值就加 没值不显示(红星)
    * 企业（就一种认证）：直接显示 qulificationinfo 字段 即可(蓝V)
    *
    * @return {icons,infos}
*/
function identify(data) {
    var result = {
        icons: [],
        infos: []
    };
    if (!(data && data.BigVip === 1 && data.OrganizationType)) {
        return result;
    }
    var isPerson = /^001/.test(data.OrganizationType); //是否是个人
    // let isCampany:boolean = /^002/.test(data.OrganizationType); //是否是企业
    //个人
    if (isPerson) {
        var infoArr = [];
        // 身份认证
        if (data.QualificationInfo) {
            infoArr.push(data.QualificationInfo);
            result.infos.push("".concat(data.QualificationInfo));
        }
        // 自媒体认证
        if (data.qualificationInfo_Zmt) {
            infoArr.push(data.qualificationInfo_Zmt);
            result.infos.push("<span>".concat(data.qualificationInfo_Zmt, "</span>"));
        }
        // 黄v 身份认证 或 自媒体
        if (data.QualificationInfo || data.qualificationInfo_Zmt) {
            result.icons.push("<i class=\"icon icon_vip\" title=\" ".concat(infoArr.join('、'), "\"></i>"));
        }
        // result.icons.push(`<i class="icon icon_vip" title=" ${infoArr.join('、')}"></i>`)
        // 个性认证
        if (data.qualificationInfo_GX) {
            result.icons.push("<i class=\"icon icon_wh\" title=\"".concat(data.qualificationInfo_GX, "\"></i>"));
            result.infos.push("<span>".concat(data.qualificationInfo_GX, "</span>"));
        }
    }
    else {
        //企业
        if (data.OrganizationType == "003006" && (!!data.IsCompanyAccount || !!data.isCompanyAccount)) {
            result.icons.push("<i class=\"icon icon_vip_qiye\" title=\"".concat(data.QualificationInfo, "\"></i>"));
            result.infos.push("".concat(data.QualificationInfo || ""));
        }
        else {
            result.icons.push("<i class=\"icon icon_vip_blue\" title=\"".concat(data.QualificationInfo, "\"></i>"));
            result.infos.push("".concat(data.QualificationInfo || ""));
        }
    }
    return result;
}
exports.default = identify;
//# sourceMappingURL=data:application/json;base64,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